export default __webpack_public_path__ + "static/connect-wallet-illustration-light-f5b541e31010169d9e1d19a3a4deefcb.svg";